import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident,
        aliquid cupiditate. Sapiente laudantium dolore ducimus animi sequi,
        repudiandae cumque ex nulla quisquam ad earum eius quia doloribus
        molestias fuga iusto placeat porro minus corrupti exercitationem eum
        omnis voluptatibus. Molestiae nulla enim suscipit obcaecati esse,
        voluptatem id sit. Et magni doloribus temporibus sunt harum a pariatur.
        Voluptates, dolorum perspiciatis eum harum quasi aspernatur animi
        laborum aliquid eveniet aperiam quam placeat ab blanditiis! Accusantium
        ratione totam pariatur numquam modi nostrum aliquid reprehenderit, illum
        dolor itaque dolorem adipisci repellat at, voluptas non saepe vitae
        obcaecati iure? Tempore voluptatum nam magnam tempora accusamus odio.
      </p>
    </section>
  );
};

export default About;
